export default __webpack_public_path__ + "static/media/undraw_online_learning.dc245ed0.svg";